import styles from './Layout.module.scss';
import { Layout as LayoutComponent } from 'antd';
import Sider from './Sider/Sider';
import Header from './Header/Header';
import Content from './Content/Content';
import useWindowSize from '../../utils/hooks/useWindowSize';
import { BREAKPOINTS } from '../../utils/constants';
import Drawer from './Drawer/Drawer';
import UpdatePasswordModal from '../UpdatePasswordModal/UpdatePasswordModal';
import { useSelector } from 'react-redux';

const Layout = props => {
    const { width: windowWidth } = useWindowSize();
    const collapsed = useSelector(state => state.siderMenu.isSiderCollapsed);

    return (
        <LayoutComponent className={styles.layout}>
            {windowWidth >= BREAKPOINTS.lg ? <Sider /> : <Drawer />}
            <LayoutComponent
                style={windowWidth >= BREAKPOINTS.lg ? (collapsed ? { marginLeft: 60 } : { marginLeft: 200 }) : {}}
            >
                <Header />
                <Content>{props.children}</Content>
            </LayoutComponent>
            <UpdatePasswordModal />
        </LayoutComponent>
    );
};

export default Layout;
